
import React, { FunctionComponent, HTMLAttributes } from "react";
import RawSvgFile from "../../resources/svg/burgermenu.svg";

export const Burgermenu: FunctionComponent<HTMLAttributes<SVGElement>> = (
  props
) => {
  return <RawSvgFile {...props} />;
};
